import { useEffect } from 'react'

import { Cache, useMutation } from '@apollo/client'

import { useModal } from '@web/components/Modal/useModal'
import { gql } from '@web/gql'
import { ConfirmResetProfileDocument } from '@web/gql/graphql'
import useMe from '@web/hooks/useMe'
import { apolloClient } from '@web/libs/apollo/client'
import { federationApolloClient } from '@web/libs/apollo/federationClient'

import ProfileResetModal from '.'

export const mutation = gql(`
  mutation ConfirmResetProfile {
    confirmResetProfile {
      success
    }
  }
`)

const useProfileResetModal = () => {
  const { me } = useMe()

  const [confirmResetProfile] = useMutation(ConfirmResetProfileDocument, {
    client: apolloClient,
    update: (cache, result) => {
      if (result.data?.confirmResetProfile.success && me) {
        const cacheId = cache.identify({ __typename: 'User', id: me.id })

        const modifyOption: Cache.ModifyOptions = {
          id: cacheId,
          fields: {
            profile: profile => ({
              ...profile,
              shouldNoticeReset: false,
            }),
          },
        }

        federationApolloClient?.cache.modify(modifyOption)
        apolloClient?.cache.modify(modifyOption)
      }
    },
  })

  const { openModal } = useModal(ProfileResetModal, {
    callback: {
      confirm: () => {
        confirmResetProfile()
      },
      cancel: () => {
        confirmResetProfile()
      },
    },
  })

  useEffect(() => {
    if (me?.profile.shouldNoticeReset) {
      openModal()
    }
  }, [me])
}

export default useProfileResetModal
